import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  faEllipsisV,
  faEnvelope,
  faLink,
  faMobileAlt,
  faPhone,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { ModalController } from '@ionic/angular';
import { Account } from '@jaimo-solutions-gmbh/platform-services-module';
import { MobilePopoverComponent } from 'src/app/modals/mobile-popover/mobile-popover.component';
import { SubscribeService } from 'src/app/subscribe.service';

type ActionType = 'website' | 'phone' | 'email';

const actionIcons: Record<ActionType, IconDefinition> = {
  website: faLink,
  phone: faMobileAlt,
  email: faEnvelope,
};

@Component({
  selector: 'app-profile-actions',
  templateUrl: './profile-actions.component.html',
  styleUrls: ['./profile-actions.component.scss'],
})
export class ProfileActionsComponent implements OnInit {
  @Output() onClick = new EventEmitter();

  @Input() account: Account;
  @Input() size: 'small' | 'medium';
  @Input() subscribeOnly: boolean;

  actions: { type: ActionType; value: string; onClick: () => void }[] = [];
  moreIcon = faEllipsisV;
  mailIcon = faEnvelope;
  phoneIcon = faPhone;

  constructor(
    private modalCtrl: ModalController,
    private subscribeService: SubscribeService
  ) {}

  ngOnInit() {
    this.convertActions();
  }

  ngAfterViewInit() {}

  open = (value: string, target: string) => window.open(value, target);

  convertActions = () => {
    if (!this.account || this.subscribeOnly) return;

    const allActions = Object.keys(this.account).filter((key) =>
      Object.keys(actionIcons).find(
        (action) => action === key && !!this.account[key]
      )
    );

    this.actions = allActions.map((type: ActionType) => {
      const value = this.account[type];

      return {
        type,
        value,
        onClick: () =>
          this.open(value, type === 'website' ? '_blank' : '_self'),
      };
    });
  };

  openSettings = async () => {
    const modal = await this.modalCtrl.create({
      component: MobilePopoverComponent,
      cssClass: 'settings-popover',
      componentProps: {
        account: this.account,
      },
    });

    modal.present();
  };

  getIcon = (actionType: ActionType) => actionIcons[actionType];

  toggleSubscribe = () => {
    this.subscribeService.toggleSubscribe(this.account);
  };
}
